import script from "./IntakeOpsReview.vue?vue&type=script&setup=true&lang=js"
export * from "./IntakeOpsReview.vue?vue&type=script&setup=true&lang=js"

import "./IntakeOpsReview.vue?vue&type=style&index=0&id=6bf5ab33&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6bf5ab33"]])

export default __exports__